export default {
    alert_details_edit: "Edit",
    alert_details_device_model: "Device Model",
    alert_details_manufacturer: "Manufacturer",
    alert_details_save: "Save",
    alert_details_edit_assignments: "Edit Assignments",
    alert_details_edit_alert_type: "Edit Alert Type",
    alert_details_edit_alert_type_success: "The alert type has been edited",
    alert_details_edit_alert_type_error: "The alert type has not been edited",
    alert_details_edit_alert_type_warning: "The device model is already on the list",
    alert_details_units_supporting: "Device Models Supporting This Alert Type",
    alert_details_no_data: "No Device Models",
    alert_details_placeholder: "Search by Device Model or Manufacturer",
    alert_details_confirm_delete: "If you cancel, the changes made will be deleted, do you want to continue?",
    alert_details_add_back: "Add back",
    alert_details_search_device_model: "Search by Device Model",
}

